import { useEffect, useState } from 'react';
import mixpanel from 'mixpanel-browser';
import { useLocation } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../../store/store';
import { MIX_PANEL_TOKEN, MODE } from '../../constants/config';
import { ROUTES } from '../../AppRouting';
import { getCurrentPath } from '../utils';
import { User } from '../../types';
import { setMixpanelInitializedSuccess } from '../../store/auth/auth.actions';

export const MixPanel = (): null => {
  const { user, isSignedInUser, isMixPanelInitialized } = useSelector(
    (state: RootState) => state.auth
  );

  const { pathname } = useLocation();

  const dispatch = useDispatch();

  const [applicationName, setApplicationName] = useState('');

  const currentRoute = ROUTES.find(
    ({ path }) => getCurrentPath(path, user) === pathname
  );

  const initialize = (id: string) => {
    mixpanel.init(id, { debug: MODE === 'local' });

    dispatch(setMixpanelInitializedSuccess());
  };

  const getPageLocationName = () => {
    let currentLocation = '';
    if (currentRoute?.label) {
      const { label } = currentRoute;
      switch (label) {
        case 'My Engagements ':
          currentLocation = `${applicationName}.my-engagements`;
          break;
        case 'Engagements':
          currentLocation = `${applicationName}.detailed-my-engagements`;
          break;
        case 'Account':
          currentLocation = `${applicationName}.account`;
          break;
        case 'Users':
          currentLocation = `${applicationName}.users`;
          break;
        case 'Apps':
          currentLocation = `${applicationName}.apps`;
          break;
        case 'Organizations':
          currentLocation = `${applicationName}.organizations`;
          break;
        case 'My Organization':
          currentLocation = `${applicationName}.myorg`;
          break;
        case 'Teams':
          currentLocation = `${applicationName}.teams`;
          break;
        case 'Performance Q':
          currentLocation = `${applicationName}.personalq`;
          break;
        case 'Performance Q ':
          currentLocation = `${applicationName}.personalq`;
          break;
        case 'My Performance Q  ':
          currentLocation = `${applicationName}.analytics`;
          break;
        default:
          break;
      }
    }

    if (pathname.includes('team-analytics/overview')) {
      currentLocation = `${applicationName}.team-q-overview`;
    } else if (pathname.includes('team-analytics/activity')) {
      currentLocation = `${applicationName}.team-q-activity`;
    } else if (pathname.includes('team-analytics/analytics')) {
      currentLocation = `${applicationName}.team-q-analytics`;
    }

    return currentLocation;
  };

  useEffect(() => {
    if (MODE !== 'local') {
      initialize(MIX_PANEL_TOKEN);

      setApplicationName('account');
    }

    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    if (
      MODE !== 'local' &&
      isSignedInUser &&
      isMixPanelInitialized &&
      user?.userId &&
      user?.orgId
    ) {
      const { userId, orgId }: User = user;

      mixpanel.identify(`${orgId}|${userId}`);

      mixpanel?.people.set_once({
        name: user?.name,
        firstName: user?.firstName,
        lastName: user?.lastName,
        orgId: user?.orgId,
        userId: user?.userId,
      });
    }

    // eslint-disable-next-line
  }, [isSignedInUser]);

  useEffect(() => {
    if (
      MODE !== 'local' &&
      applicationName?.length &&
      isSignedInUser &&
      isMixPanelInitialized
    ) {
      mixpanel.track(getPageLocationName());
    }

    // eslint-disable-next-line
  }, [pathname, isSignedInUser]);

  return null;
};
